import { useEffect, useRef, useState } from "react";
import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import BottomNavigationBar from "../BottomNavigation";
import "../GridFilter.css";
import "datatables.net";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import FilterListIcon from "@mui/icons-material/FilterList";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TablePagination } from "@mui/material";

import $ from "jquery";
import "datatables.net";
import "datatables.net-fixedheader";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@mui/material";
import {
  setAgent,
  setCity,
  setHotel,
  setModalParams,
} from "../../Store/Slices/countrySlice";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { BounceLoader } from "react-spinners";
import { makePostRequest } from "../../API";

// import { DatePicker, Space } from 'antd';
const { RangePicker } = DatePicker;

function NotArrangeHotelGrid() {
  const [loading, setLoading] = useState(false);
  const dateFormat = "YYYY-MM-DD";
  const storeState = useSelector((state) => state);
  const modalMapping = storeState.Country.modalMapping;
  const dispatch = useDispatch();

  const state_endpoints_mapping = {
    agent_country: {
      endpoint: "api/agent",
      field: "country_code",
      dispatchFunction: setAgent,
      dependent: "agents",
    },
    country: {
      endpoint: "api/world/cities",
      field: "country_id",
      dispatchFunction: setCity,
      dependent: "city",
    },
    city: {
      endpoint: "api/hotel",
      field: "city_id",
      dispatchFunction: setHotel,
      dependent: "hotel",
    },
    voucherId: null,
    agent: null,
    hotel: null,
    arrivalDate: null,
    returnDate: null,
    checkIn: null,
    checkOut: null,
    completed: null,
  };

  const todayDate = moment(new Date()).format(dateFormat);

  const [state, setState] = useState({
    length: 100,
    start: 0,
    draw: 1,
    voucher_id: null,
    agent_country: null,
    country: null,
    agents: null,
    city: null,
    hotel: null,
    check_in_date_from: null,
    check_in_date_to: null,
    check_out_date_from: null,
    check_out_date_to: null,
    arrival_date_from: null,
    arrival_date_to: null,
    checkInDateTo: null,
    return_date_from: null,
    return_date_to: null,
    completed: "no",
  });

  const Dates = {
    arrival_date: ["arrival_date_from", "arrival_date_to"],
    return_date: ["return_date_from", "return_date_to"],
    travel_date: ["check_out_date_from", "check_out_date_to"],
    checkin_date: ["check_in_date_from", "check_in_date_to"],
  };

  const loadData = async (state_id, value) => {
    if (state_endpoints_mapping[state_id] == null) return;

    console.log("State Id", state_id);

    setLoading(true);

    const response = await makePostRequest(
      state_endpoints_mapping[state_id].endpoint,
      { [state_endpoints_mapping[state_id].field]: value }
    );

    console.log("Response is ", response.data);

    if (response.status == "success") {
      dispatch(
        state_endpoints_mapping[state_id].dispatchFunction(response.data)
      );
      // setState({
      //   ...state,
      //   [state_endpoints_mapping[state_id].dependent]: response.data,
      // });
    }

    setLoading(false);
  };

  const handleChange = async (e) => {
    e.preventDefault();
    setState({ ...state, [e.target.id]: e.target.value });
    await loadData(e.target.id, e.target.value);
  };

  const handleDates = (e, id) => {
    console.log(e);
    if (e !== null) {
      const date_from = moment(e[0].$d).format(dateFormat);
      const date_to = moment(e[1].$d).format(dateFormat);
      console.log(date_from, date_to);
      console.log(Dates);

      // console.log("Date is :", date);
      setState({
        ...state,
        [Dates[id][0]]: date_from,
        [Dates[id][1]]: date_to,
      });
    } else {
      setState({
        ...state,
        [Dates[id][0]]: null,
        [Dates[id][1]]: null,
      });
    }
  };

  const [isFormVisible, setFormVisible] = useState(false);
  //     const { RangePicker } = DatePicker;
  // const dateFormat = "YYYY/MM/DD";
  // const today = new Date().toISOString().split("T")[0];

  const handleFilterClick = () => {
    setFormVisible(!isFormVisible);
  };
  const tableRef = useRef(null);

  useEffect(() => {
    $(tableRef.current).DataTable();

    return () => {
      // Destroy the DataTable instance when the component unmounts
      $(tableRef.current).DataTable().destroy(true);
    };
  }, []);

  // Actual Hotel

  const [tableData1, setTableData1] = useState([]);

  useEffect(() => {
    fetchData1();
  }, []);

  const fetchData = async () => {
    const endpoint = "api/umrah/actual-hotel-activity";
    try {
      setLoading(true);
      const response = await makePostRequest(endpoint, state);
      // new12
      // console.log("..........", response);
      setLoading(false);
      // Assuming the response contains the 'data' array
      if (response && response.data && response.data.data) {
        setTableData1(response.data.data);
        // new12
        // console.log(tableData1, "Actual hotel......................1");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // here date state will be added to params
  const fetchData1 = async () => {
    const endpoint = "api/umrah/actual-hotel-activity";
    const params = {
      length: 100,
      start: 0,
      draw: 1,
      completed: "no",
      // check_in_date_from: "2020-05-15",
      // check_in_date_to: "2023-07-15",
    };
    try {
      setLoading(true);
      const response = await makePostRequest(endpoint, params);
      // new12
      // console.log("..........", response);
      setLoading(false);
      // Assuming the response contains the 'data' array
      if (response && response.data && response.data.data) {
        setTableData1(response.data.data);
        // new12
        // console.log(tableData1, "Actual hotel......................1");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };
  const [modalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();

  const openModal = (e) => {
    e.preventDefault();
    console.log(e.target.id);
    dispatch(setModalParams(e.target.id.split(",")));
    navigate("/datamodal");
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [DateError, SetDateError] = useState({
    arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    travelFrom: false,
    travelTo: false,
    checkInFrom: false,
    checkInTo: false,
  });

  const handle_date_from = (e, positionFrom, ErrorPosition, StateCompare) => {
    const date_from = moment(e.$d).format(dateFormat);
    setState((prevState) => ({
      ...prevState,
      [positionFrom]: date_from,
    }));

    if (date_from && state[StateCompare] && date_from > state[StateCompare]) {
      SetDateError({
        ...DateError,
        [ErrorPosition]: true,
      });

      setState((prevState) => ({
        ...prevState,
        [positionFrom]: null,
      }));
    } else {
      SetDateError({
        ...DateError,
        [ErrorPosition]: false,
      });
    }
  };

  const handle_date_to = (
    e,
    positionto,
    DateErrorTo,
    DateErrorFrom,
    StateCompare
  ) => {
    const date_to = moment(e.$d).format(dateFormat);

    if (!state[StateCompare] || (date_to && date_to >= state[StateCompare])) {
      setState({
        ...state,
        [positionto]: date_to,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: false,
        [DateErrorFrom]: false,
      });
    } else {
      setState({
        ...state,
        [positionto]: null,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: true,
      });
    }
  };

  // adding a  background white when we scroll down
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // pagination layout

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  // Slice data for pagination
  const paginatedData = tableData1.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div>
      <MDBContainer breakpoint=" ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="row mb-5 ">
            <div
              className={`mb-3 grid-filter-inputs flex-display-container align-items-center  sticky-top rounded  p-4 ${
                isScrolled ? "bg-white" : ""
              } `}
            >
              <h1 className="main-hading">Not Arranged Hotel</h1>
              <button onClick={handleFilterClick} className="filter-button">
                Filters {<FilterListIcon />}
              </button>
            </div>
            <div className="row">
              <hr />
            </div>
            {isFormVisible && (
              <div className="row">
                <div className="col-md-12 mx-auto">
                  <div className="row">
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="voucher_id" className="lableSize">
                          Voucher ID
                        </label>
                        <input
                          type="text"
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          onChange={handleChange}
                          id="voucher_id"
                          name="VoucherId"
                          placeholder="Voucher ID"
                          value={state.voucher_id}
                        />
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="agent_country" className="lableSize">
                          Agent Country{" "}
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agent_country"
                          name="agent_country"
                          onChange={handleChange}
                          value={state.agent_country}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.listCountry.map((country) => {
                            return (
                              <option key={country[0]} value={country[0]}>
                                {country[1]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="agents" className="lableSize">
                          Agents
                        </label>
                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agents"
                          value={state.agent}
                          onChange={handleChange}
                        >
                          <option value="">Select Agent</option>
                          {storeState.Country.agents.map((ag) => (
                            <option key={ag.UID} value={ag.UID}>
                              {ag.FullName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="country" className="lableSize">
                          Country{" "}
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="country"
                          name="Country"
                          onChange={handleChange}
                          value={state.country}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.listCountry.map((country) => (
                            <option key={country[0]} value={country[0]}>
                              {country[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="city" className="lableSize">
                          City
                        </label>
                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="city"
                          name="City"
                          onChange={handleChange}
                          value={state.city}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.city.map((city) => (
                            <option key={city.UID} value={city.UID}>
                              {city.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="hotel" className="lableSize">
                          Hotel
                        </label>
                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="hotel"
                          name="Hotel"
                          onChange={handleChange}
                          value={state.hotel}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.hotel.map((trans) => (
                            <option key={trans.UID} value={trans.UID}>
                              {trans.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* CHECKin -------------------------------------------------------------- */}

                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      CheckIn Date
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.check_in_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "check_in_date_from",
                                "checkInFrom",
                                "check_in_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.checkInFrom
                                  ? "1px solid red"
                                  : "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.checkInFrom ||
                        (DateError.checkInFrom &&
                          state.check_in_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.check_in_date_from == null &&
                        !DateError.checkInFrom ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.check_in_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.checkInTo
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.checkInTo ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "check_in_date_to",
                                "checkInTo",
                                "checkInFrom",
                                "check_in_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.checkInTo ||
                        (DateError.checkInTo &&
                          state.check_in_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.check_in_date_to == null &&
                        !DateError.checkInTo ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* Check in  */}

                    {/* ARIVAL-------------------------------------------------------------- */}

                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      Arrival Date
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "arrival_date_from",
                                "arivalErrorFrom",
                                "arrival_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.arivalErrorFrom
                                  ? "1px solid red"
                                  : "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.arivalErrorFrom ||
                        (DateError.arivalErrorFrom &&
                          state.arrival_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.arrival_date_from == null &&
                        !DateError.arivalErrorFrom ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.arivalError
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.arivalError ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "arrival_date_to",
                                "arivalError",
                                "arivalErrorFrom",
                                "arrival_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.arivalError ||
                        (DateError.arivalError &&
                          state.arrival_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.arrival_date_to == null &&
                        !DateError.arivalError ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* end Arival  */}

                    {/* RETURN-------------------------------------------------------------- */}
                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Return Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "return_date_from",
                                "returnFrom",
                                "return_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.returnFrom
                                  ? "1px solid red"
                                  : "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.returnFrom ||
                        (DateError.returnFrom &&
                          state.return_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.return_date_from == null &&
                        !DateError.returnFrom ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.returnTo
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.returnTo ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "return_date_to",
                                "returnTo",
                                "returnFrom",
                                "return_date_from"
                              )
                            }
                            autoFocus={false}
                            // Add custom class here
                          />
                        </DemoContainer>

                        {DateError.returnTo ||
                        (DateError.returnTo && state.return_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.return_date_to == null && !DateError.returnTo ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    {/* TRAVEL DATE-------------------------------------------------------------- */}

                    <label
                      for="
                      travel_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Travel Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="travel_date_from" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "travel_date_from",
                                "travelFrom",
                                "travel_date_to"
                              )
                            }
                            value={dayjs(state.travel_date_from, dateFormat)}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.travelFrom
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.travelFrom ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.travelFrom ||
                        (DateError.travelFrom &&
                          state.travel_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.travel_date_from == null &&
                        !DateError.travelFrom ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.travel_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.travelTo
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.travelTo ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "travel_date_to",
                                "travelTo",
                                "travelFrom",
                                "travel_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.travelTo ||
                        (DateError.travelTo && state.travel_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {state.travel_date_to == null && !DateError.travelTo ? (
                          <div>
                            <p
                              className="text-danger mt-3 f-bold fs-5 "
                              style={{ marginLeft: "4px" }}
                            >
                              * PLEASE SELECT TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* date section end ---------------------------------------------------------------------------------------- */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="country" className="lableSize">
                          Completed
                        </label>
                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="completed"
                          name="completed"
                          value={state.completed}
                          onChange={handleChange}
                        >
                          <option value="">Please Select</option>
                          <option value="yes">Yes</option>
                          <option value="no" selected="">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      className="col-md-12"
                      id="AllowTransportActiviitesAjaxResult"
                    ></div>
                    <div className="col-md-12" id="FilterButtons">
                      <div className="form-group htjfdgr">
                        <button
                          onClick={fetchData}
                          id="btnsearch"
                          type="button"
                          className="btn btn-success fs-1"
                          style={{ marginRight: "12px", padding: "8px 25px" }}
                        >
                          Search
                        </button>
                        <button
                          onClick={() =>
                            setState({
                              length: 100,
                              start: 0,
                              draw: 1,
                              voucher_id: "",
                              agent_country: "",
                              country: "",
                              agents: "",
                              city: "",
                              hotel: "",
                              check_in_date_from: null,
                              check_in_date_to: null,
                              check_out_date_from: null,
                              check_out_date_to: null,
                              arrival_date_from: null,
                              arrival_date_to: null,
                              checkInDateTo: null,
                              return_date_from: null,
                              return_date_to: null,
                              completed: "no",
                            })
                          }
                          id="btnreset"
                          type="button"
                          className="btn btn-danger fs-1"
                          style={{ padding: "8px 25px" }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div style={{ marginBottom: "20px" }}>
              <Paper sx={{ padding: "0px 20px" }}>
                <Table
                  id="example"
                  className="table table-striped dt-responsive nowrap table-display w-100"
                >
                  {/* Table Head */}
                  <TableHead>
                    <TableRow>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Voucher
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Agent
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Hotel Name
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          align="center"
                          style={{ height: "35vh" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <BounceLoader className="BouncingLoader" />
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                    
                    
                                                              : paginatedData?.length === 0 ? (
                                                                                                      <TableRow>
                                                                                                        <TableCell colSpan={3} align="center" style={{ height: "25vh" }}> 
                                                                                                          <h3 className="pt-5">
                                                                                
                                                                                                          No data found
                                                                                                          </h3>
                                                                                                        </TableCell>
                                                                                                      </TableRow>
                                                                                                    )
                                                                                
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    : (
                      paginatedData?.map((item, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell
                              component="td"
                              sx={{ cursor: "pointer" }}
                              onClick={() => toggleExpansion(index)}
                            >
                              {item.voucher_id}
                            </TableCell>
                            <TableCell component="td">{item.agent}</TableCell>
                            <TableCell component="td">
                              {item.hotel_name || "--"}
                            </TableCell>
                          </TableRow>

                          {/* Expanded Row */}
                          {expandedRows[index] && (
                            <TableRow>
                              <TableCell component="td" colSpan={3}>
                                <div className="row">
                                  {[
                                    {
                                      label: "Activity UID ",
                                      value: item.activity_uid,
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Room Type ",
                                      value: item.room_type_name || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Check In Date ",
                                      value: item.check_in || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "No Of Days ",
                                      value: item.days || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Hotel Name ",
                                      value: item.hotel_name || "--",
                                      colClass: "col-12",
                                    }, // Full width
                                  ].map((field, idx) => (
                                    <div
                                      key={idx}
                                      className={`${field.colClass} d-flex flex-column mb-3`}
                                    >
                                      <b>{field.label}:</b> {field.value}
                                    </div>
                                  ))}
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                    )}
                  </TableBody>

                  {/* Pagination */}
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    component="paper" 
                    count={tableData1.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      "& .MuiTablePagination-displayedRows": { margin: 0 },
                      "& .MuiTablePagination-selectLabel": { margin: 0 },
                      "& .MuiSelect-select": { margin: 0 },
                    }}
                  />
                </Table>
              </Paper>
            </div>
          </div>
        </LocalizationProvider>
      </MDBContainer>
      <div>
        <BottomNavigationBar />
      </div>
    </div>
  );
}

export default NotArrangeHotelGrid;
